// ==============================|| ACTIVITATE UTILIZATOR (pentru refresh gated) ||============================== //
// Momentul ultimei interacțiuni REALE (evenimente DOM). Reînnoirea proactivă a tokenului
// se face DOAR cât timp userul e activ — sesiunile IDLE nu trebuie ținute vii la nesfârșit
// (securitate: fiecare refresh resetează idle-timer-ul de sesiune din Keycloak).

let lastActivity = Date.now();

// Keep every token consumer on the same idle policy. Background polling must never silently
// extend a Keycloak session after this window has elapsed.
export const ACTIVE_REFRESH_WINDOW_MS = 5 * 60_000;

export const markActivity = (): void => {
	lastActivity = Date.now();
};

// true dacă a existat activitate în ultimele `windowMs` milisecunde.
export const isUserActive = (windowMs: number): boolean =>
	Date.now() - lastActivity <= windowMs;
